<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex py-5 px-5">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="w-full md:w-1/2 px-3 mb-6 required">
          <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          >User Group Name</label
          >
          <validation-provider v-slot="{ errors }"
                               :rules="{
              required: true,
              regex:
              '^[A-Za-z][A-Za-z ]*$'
            }">
            <input
                id="groupName"
                v-model="formValues.groupName"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name
                type="text"
            />
            <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
          </validation-provider>
        </div>
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
          <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          >Group Roles</label
          >
          <validation-provider v-slot="{ errors }" rules="required">
            <v-select
                v-model="formValues.groupRoleIds"
                :items="ROLES"
                chips
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                hint="Select roles"
                item-text="roleName"
                item-value="id"
                multiple
                persistent-hint
            >
            </v-select>

            <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
          </validation-provider>

          <br/>
        </div>
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
          <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          >Description</label
          >
          <validation-provider v-slot="{ errors }" rules="required">
            <textarea
                v-model="formValues.description"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter group description."
                rows="3"
            ></textarea>

            <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
          </validation-provider>
          <br/>
        </div>

        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full">
            <button
                class="float-right shadow bg-teal-600 hover:bg-teal-600 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                type="button"
                @click="submit()"
            >
              {{ formValues.editMode ? "Update User Group" : "Add User Group" }}
            </button>
          </div>
          <div class="md:w-2/3"></div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>


<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {min_value, regex, required} from "vee-validate/dist/rules";
import {RoleService} from "../Role/role.service";

extend("required", {
  ...required,
  message: "This field is required",
});
extend("regex", {
  ...regex,
  message: "Name should contain only letters",
});

extend("min_value", {
  ...min_value,
  message: "Invalid Value",
});
export default {
  props: {
    userGroup: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        groupName: "",
        groupRoleIds: "",
        description: "",
        editMode: false,
      },
      showProgress: false,
      ROLES: [],
    };
  },
  async beforeMount() {
    this.fetchRoles();
  },
  created() {
    if (this.userGroup != null) {
      this.formValues = this.userGroup;
      let groupRoleIds = [];
      this.userGroup.roles.forEach((role) => {
        groupRoleIds.push(role.id);
      });
      this.formValues.groupRoleIds = groupRoleIds;
      this.formValues.editMode = true;
    }
  },
  methods: {
    async fetchRoles() {
      this.loading = true;
      const res = await RoleService.getRoles();
      if (res.status === 200) {
        this.loading = false;
        this.ROLES = res.data.rows;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching roles, Please try Again!"
        );
      }
    },
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("registerOrUpdateUserGroup", this.formValues);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>